module.exports = __webpack_public_path__ + "img/locationMap.b0dcdfde.png";